import Vue from 'vue';
import Croppa from 'vue-croppa';
 
Vue.use(Croppa);